/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ReportAppMessageDeliveredRequest} from '@cash-web/protos/squareup/cash/messagingplatformcommon/app/AppServiceProto.pb'
import {ReportAppMessageDeliveredResponse} from '@cash-web/protos/squareup/cash/messagingplatformcommon/app/AppServiceProto.pb'


export const reportAppMessageDelivered = (request: ReportAppMessageDeliveredRequest, options?: CashRequestOptions) => post<ReportAppMessageDeliveredRequest, ReportAppMessageDeliveredResponse>("/2.0/cash/report-app-message-delivered", request, {...options, rejectOnError: true })